export default __webpack_public_path__ + "static/media/twitter-inverted.4f9be95c.png";